module.exports = __webpack_public_path__ + "static/media/VPM_tablet_2.9b21d3a9.jpg";